/**
 * Partner Login Dialog
 *
 * Dummy login form used to give the site a more established appearance.
 * No real authentication — submission always shows the error state and shakes the button.
 */
export function initPartnerLogin() {
    const link = document.querySelector('[data-partner-login]');
    const dialog = document.getElementById('partner-login-dialog');
    if (!link || !dialog) return;

    link.addEventListener('click', (e) => {
        e.preventDefault();
        dialog.showModal();
    });

    const closeBtn = dialog.querySelector('.dialog-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => dialog.close());
    }

    dialog.addEventListener('click', (e) => {
        if (e.target === dialog) dialog.close();
    });

    const form = document.getElementById('partner-login-form');
    const errEl = document.getElementById('partner-login-error');
    const submitBtn = form ? form.querySelector('.partner-login-submit') : null;

    if (form && errEl && submitBtn) {
        form.addEventListener('submit', (e) => {
            e.preventDefault();
            errEl.hidden = false;
            submitBtn.classList.add('partner-login-shake');
            setTimeout(() => submitBtn.classList.remove('partner-login-shake'), 500);
        });
    }
}
